import React from "react";
import "./Hero.css";
import heroImage from "../images/4.png";

const Hero = () => (
  <section className="hero" id="top">
    <div className="hero__glow" aria-hidden="true" />

    <div className="container hero__inner">
      <div className="hero__copy">
        <span className="eyebrow">Multi-stop route planner</span>

        <h1 className="hero__title">
          Travel <em>simpler</em>
          <br />
          and easier.
        </h1>

        <p className="lede hero__lede">
          Drop in an origin, up to twelve stops and a destination. TravelEase
          reorders them into the shortest run so you spend the day arriving,
          not backtracking.
        </p>

        <div className="hero__actions">
          <a className="btn" href="#planner">
            Plan a route
            <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path
                d="M4 10h11m0 0-4.2-4.2M15 10l-4.2 4.2"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
          <a className="btn btn--ghost" href="#how">
            How it works
          </a>
        </div>

        <dl className="hero__stats">
          <div>
            <dt>Stops per route</dt>
            <dd>up to 12</dd>
          </div>
          <div>
            <dt>Ordering</dt>
            <dd>2-opt refined</dd>
          </div>
          <div>
            <dt>Setup</dt>
            <dd>no account</dd>
          </div>
        </dl>
      </div>

      <div className="hero__art">
        <img
          src={heroImage}
          alt="Isometric papercraft city rising out of a phone screen"
          width="1100"
          height="1100"
          fetchpriority="high"
        />
        <div className="hero__badge">
          <span className="hero__badge-dot" />
          <div>
            <strong>Route optimised</strong>
            <span>7 stops reordered</span>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
